interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  action?: { label: string; href: string; onClick: () => void };
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  action,
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div
      className={`mb-8 md:mb-10 ${
        isCenter
          ? "text-center max-w-2xl mx-auto"
          : "flex flex-col md:flex-row md:items-end md:justify-between gap-4"
      }`}
    >
      <div className={isCenter ? "" : "max-w-2xl"}>
        <span className="inline-flex items-center gap-1.5 text-xs md:text-sm font-medium tracking-widest text-primary-600 mb-3">
          <i className="ri-subtract-line" />
          {eyebrow}
        </span>
        <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-3xl lg:text-4xl leading-snug">
          {title}
        </h2>
        {desc && (
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>
        )}
      </div>
      {action && !isCenter && (
        <a
          href={action.href}
          onClick={(e) => {
            e.preventDefault();
            action.onClick();
          }}
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md border border-background-300 text-sm text-foreground-800 hover:border-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer self-start md:self-auto"
        >
          {action.label}
          <i className="ri-arrow-right-line" />
        </a>
      )}
    </div>
  );
}